import { motion } from "framer-motion";

const BARS = [
  { label: "Availability", value: 92 },
  { label: "Performance", value: 89 },
  { label: "Quality", value: 98 },
];

const TREND = "0,62 30,56 60,63 90,42 120,47 150,32 180,40 210,24 240,30 270,16 300,19";

export const MockDashboard = () => (
  <div
    data-testid="mock-dashboard"
    className="bg-[#0b0f0e] border border-white/10 p-6 lg:p-8 text-white shadow-2xl shadow-teal-500/10"
  >
    <div className="flex items-center justify-between">
      <span className="font-display text-xs tracking-[0.3em] text-teal-400">PRESS SHOP · OEE</span>
      <span className="flex items-center gap-2 text-xs text-white/60">
        <span className="w-1.5 h-1.5 rounded-full bg-green-400 node-pulse" />
        LIVE
      </span>
    </div>

    <div className="mt-8 flex items-end gap-4">
      <span className="font-display font-black text-6xl leading-none tracking-tight">
        87.4<span className="text-3xl">%</span>
      </span>
      <span className="text-green-400 text-sm mb-1.5">+2.1% vs last shift</span>
    </div>

    <div className="mt-8 space-y-4">
      {BARS.map((bar, i) => (
        <div key={bar.label}>
          <div className="flex justify-between text-xs text-white/60 mb-1.5">
            <span>{bar.label}</span>
            <span className="text-white/90 font-medium">{bar.value}%</span>
          </div>
          <div className="h-1.5 bg-white/10 overflow-hidden">
            <motion.div
              initial={{ width: 0 }}
              whileInView={{ width: `${bar.value}%` }}
              viewport={{ once: true }}
              transition={{ duration: 1.2, delay: 0.2 + i * 0.15, ease: [0.16, 1, 0.3, 1] }}
              className="h-full bg-gradient-to-r from-teal-400 to-green-400"
            />
          </div>
        </div>
      ))}
    </div>

    <div className="mt-8">
      <p className="text-xs text-white/60 mb-2">OEE trend · last 12 hours</p>
      <svg viewBox="0 0 300 80" className="w-full h-20">
        <motion.polyline
          points={TREND}
          fill="none"
          stroke="#2dd4bf"
          strokeWidth="2"
          strokeLinejoin="round"
          strokeLinecap="round"
          initial={{ pathLength: 0 }}
          whileInView={{ pathLength: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.8, delay: 0.4, ease: "easeOut" }}
        />
        <circle cx="270" cy="16" r="3" fill="#4ade80" />
      </svg>
    </div>

    <div className="mt-6 border border-teal-500/30 bg-teal-500/5 p-4">
      <p className="font-display text-[10px] tracking-[0.3em] text-teal-400">ROOT CAUSE IDENTIFIED</p>
      <p className="mt-2 text-sm font-medium">Infeed sensor fault — Line 3, 14:02 UTC</p>
      <p className="mt-2 text-[11px] font-mono text-white/50">
        trace → historian:P3-114 · alarm:A-221 · SOP-7.3
      </p>
    </div>
  </div>
);
